<template>
  <div class="form__errors" v-if="errors && errors.length">
    <div class="form__error">
      {{ errors[0] }}
    </div>
  </div>
</template>


<script>
export default {
  name: "FormError",
  props: {
    errors: {
      type: Array,
    },
  },
};
</script>